module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "naver"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "活动信息",
      "description": "填写活动信息，* 号项为必填项！",
      "type": "success",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称：",
      "prop": "name",
      "rules": _vm.rules.names
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 80,
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间：",
      "rules": _vm.rules.activity_date
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台类型：",
      "rules": _vm.rules.platform
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.platform),
      callback: function($$v) {
        _vm.$set(_vm.form, "platform", $$v)
      },
      expression: "form.platform"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "online"
    }
  }, [_vm._v("线上")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "pos"
    }
  }, [_vm._v("线下")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指定来源：",
      "prop": "origin",
      "rules": _vm.rules.origin
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.origin),
      callback: function($$v) {
        _vm.$set(_vm.form, "origin", $$v)
      },
      expression: "form.origin"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "POS"
    }
  }, [_vm._v("线下POS")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "YKDJ"
    }
  }, [_vm._v("怡康到家")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "BJRBJK"
    }
  }, [_vm._v("宝鸡人保健康")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "医保品：",
      "rules": _vm.rules.is_medical
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_medical),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_medical", $$v)
      },
      expression: "form.is_medical"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'pos'),
      expression: "form.platform === 'pos'"
    }],
    attrs: {
      "label": "区域公司："
    }
  }, [_c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择公司(默认怡康连锁)",
      "size": "",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": _vm.searchLog
    },
    model: {
      value: (_vm.corporation_ids),
      callback: function($$v) {
        _vm.corporation_ids = $$v
      },
      expression: "corporation_ids"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全选",
      "value": _vm.allCompanyIds
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAll.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.companyList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板类型：",
      "rules": _vm.rules.show_type
    },
    model: {
      value: (_vm.form.show_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_type", $$v)
      },
      expression: "form.show_type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.show_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_type", $$v)
      },
      expression: "form.show_type"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'pos'),
      expression: "form.platform === 'pos'"
    }],
    attrs: {
      "label": 0
    }
  }, [_vm._v("小票金额累计")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'pos'),
      expression: "form.platform === 'pos'"
    }],
    attrs: {
      "label": 1
    }
  }, [_vm._v("单张小票达标")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'pos'),
      expression: "form.platform === 'pos'"
    }],
    attrs: {
      "label": 5
    }
  }, [_vm._v("单张小票达标（随机概率）")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'pos'),
      expression: "form.platform === 'pos'"
    }],
    attrs: {
      "label": 2
    }
  }, [_vm._v("会员日活动（累计）")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'pos'),
      expression: "form.platform === 'pos'"
    }],
    attrs: {
      "label": 4
    }
  }, [_vm._v("会员日活动（不累计）")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.platform === 'online'),
      expression: "form.platform === 'online'"
    }],
    attrs: {
      "label": 3
    }
  }, [_vm._v("线上专享")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消费类型：",
      "rules": _vm.rules.cos_type
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.cos_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "cos_type", $$v)
      },
      expression: "form.cos_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("消费")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("积分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抽奖门槛：",
      "rules": _vm.rules.entry
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.entry),
      callback: function($$v) {
        _vm.$set(_vm.form, "entry", $$v)
      },
      expression: "form.entry"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("有")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("无")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.entry === 0),
      expression: "form.entry === 0"
    }],
    attrs: {
      "label": "门槛金额：",
      "prop": "cos_fee",
      "rules": _vm.rules.cos_fee
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 200,
      "placeholder": "积分或者消费金额"
    },
    model: {
      value: (_vm.form.cos_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "cos_fee", $$v)
      },
      expression: "form.cos_fee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抽奖次数：",
      "rules": _vm.rules.times
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "maxlength": 20,
      "placeholder": "本次活动最大抽奖次数"
    },
    model: {
      value: (_vm.form.times),
      callback: function($$v) {
        _vm.$set(_vm.form, "times", $$v)
      },
      expression: "form.times"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.show_type === 2 || _vm.form.show_type === 4),
      expression: "form.show_type === 2 || form.show_type === 4"
    }],
    attrs: {
      "label": "指定日期："
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "rows": 3,
      "placeholder": "输入星期几1,2,3,4,5,6,7，用英文逗号隔开，默认周一至周日"
    },
    model: {
      value: (_vm.form.weekends),
      callback: function($$v) {
        _vm.$set(_vm.form, "weekends", $$v)
      },
      expression: "form.weekends"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "5px"
    },
    attrs: {
      "label": "背景图：",
      "rules": _vm.rules.bac_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('bac_img', _vm.index)
      }
    }
  }, [(_vm.form.bac_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.bac_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：图片|只能上传jpg/png文件，尺寸为1170*2260，单位为px，且不超过500KB\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/28/a14488b112d9d032e0f952c7d4883b77olxlXpEdZfUrA8r9Ts5rLhZkwEDmcORr",
      "preview-src-list": _vm.srcList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "转盘背景图：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('circle_img', _vm.index)
      }
    }
  }, [(_vm.form.circle_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.circle_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：图片|只能上传jpg/png文件，尺寸为835*835，单位为px，且不超过500KB\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/05/31/b23af3d7d29df5b406a4aae75e12410byhOTaViFOluzOxIR2iSGurSqHAtk6BYP",
      "preview-src-list": _vm.srcList1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "转盘配置：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px dotted #409EFF",
      "height": "280px"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "宽度(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宽度"
    },
    model: {
      value: (_vm.form.zpWidth),
      callback: function($$v) {
        _vm.$set(_vm.form, "zpWidth", $$v)
      },
      expression: "form.zpWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "上边距(vw)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入上边距"
    },
    model: {
      value: (_vm.form.zpMarginTop),
      callback: function($$v) {
        _vm.$set(_vm.form, "zpMarginTop", $$v)
      },
      expression: "form.zpMarginTop"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "左边距(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入左边距"
    },
    model: {
      value: (_vm.form.zpMarginLeft),
      callback: function($$v) {
        _vm.$set(_vm.form, "zpMarginLeft", $$v)
      },
      expression: "form.zpMarginLeft"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        默认值：宽度 69，上边距 70.5，左边距 16.5\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "圆盘指针：",
      "rules": _vm.rules.point_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('point_img', _vm.index)
      }
    }
  }, [(_vm.form.point_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.point_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：图片|只能上传jpg/png文件，尺寸为240*240，单位为px，且不超过500KB\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/22/1071a4e805be6bcbc1b87161411d1693wYvO2Y2eoMasmtONXi87wmhFD2B0eH0N",
      "preview-src-list": _vm.srcList2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "指针配置：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px dotted #409EFF",
      "height": "280px"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "宽度(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宽度"
    },
    model: {
      value: (_vm.form.zzWidth),
      callback: function($$v) {
        _vm.$set(_vm.form, "zzWidth", $$v)
      },
      expression: "form.zzWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "高度(vw)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入上边距"
    },
    model: {
      value: (_vm.form.zzHeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "zzHeight", $$v)
      },
      expression: "form.zzHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "上边距(vw)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入左边距"
    },
    model: {
      value: (_vm.form.zzMarginTop),
      callback: function($$v) {
        _vm.$set(_vm.form, "zzMarginTop", $$v)
      },
      expression: "form.zzMarginTop"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "左边距(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入左边距"
    },
    model: {
      value: (_vm.form.zzMarginLeft),
      callback: function($$v) {
        _vm.$set(_vm.form, "zzMarginLeft", $$v)
      },
      expression: "form.zzMarginLeft"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        备注：宽度 26，高度 25，上边距 93，左边距 38\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "抽奖规则：",
      "rules": _vm.rules.rule_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('rule_img', _vm.index)
      }
    }
  }, [(_vm.form.rule_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.rule_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：图片|只能上传jpg/png文件，外部弹出层：1080*1833，内部弹窗居中最大宽度限制：1000px\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/11/e94c2edd6fe217a826a6892fe3f1c8317lRAT3OzkyP1G2TAn8BNpszovc7wRFAY",
      "preview-src-list": _vm.srcList3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "抽奖规则配置：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticClass: "frm-tips",
    staticStyle: {
      "height": "280px",
      "border": "1px dotted #409EFF"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "宽度(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宽度"
    },
    model: {
      value: (_vm.form.cjgzWidth),
      callback: function($$v) {
        _vm.$set(_vm.form, "cjgzWidth", $$v)
      },
      expression: "form.cjgzWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        默认值：宽度 99\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "规则+记录：",
      "rules": _vm.rules.all_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('all_img', _vm.index)
      }
    }
  }, [(_vm.form.all_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.all_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：图片|只能上传jpg/png文件，尺寸为953*261，单位为px，且不超过500KB\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/22/9afaa26e4ae94b450cef39e4b3c3da2fICwked6MwwNFPJf7T6PONGHZOH18XNhy",
      "preview-src-list": _vm.srcList4
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "抽奖记录背景：",
      "rules": _vm.rules.rec_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('rec_img', _vm.index)
      }
    }
  }, [(_vm.form.rec_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.rec_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：奖品图片|只能上传jpg/png文件，外部弹出层：1080*1833，内部弹窗居中最大宽度限制：1000px\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/22/9c2acfc1f738dae297506721c1592164ikzubM8hH7HOxhW55AxgjC9XADMzvBy7",
      "preview-src-list": _vm.srcList5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "1px"
    },
    attrs: {
      "label": "中奖记录配置：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px dotted #409EFF"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "记录宽度(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宽度"
    },
    model: {
      value: (_vm.form.zjjlWidth),
      callback: function($$v) {
        _vm.$set(_vm.form, "zjjlWidth", $$v)
      },
      expression: "form.zjjlWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "记录高度(vw)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入记录高度"
    },
    model: {
      value: (_vm.form.zjjlHeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "zjjlHeight", $$v)
      },
      expression: "form.zjjlHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "列表宽度(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入列表宽度"
    },
    model: {
      value: (_vm.form.lbWidth),
      callback: function($$v) {
        _vm.$set(_vm.form, "lbWidth", $$v)
      },
      expression: "form.lbWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "列表高度(vh)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入列表高度"
    },
    model: {
      value: (_vm.form.lbHeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "lbHeight", $$v)
      },
      expression: "form.lbHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "列表上边距(vw)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入列表上边距"
    },
    model: {
      value: (_vm.form.lbMarginTop),
      callback: function($$v) {
        _vm.$set(_vm.form, "lbMarginTop", $$v)
      },
      expression: "form.lbMarginTop"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        备注：中奖记录--- 宽度 90 ，高度 126，中奖列表---  宽度 77 ，高度 54 ，上边距 20\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "地址背景图：",
      "rules": _vm.rules.address_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('address_img', _vm.index)
      }
    }
  }, [(_vm.form.address_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.address_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：奖品图片|只能上传jpg/png文件，外部弹出层：1080*1833，内部弹窗居中最大宽度限制：1000px\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/22/7c2f351b16b75a98db48a5f7ae04b50cRF8ivot3RRF05Y0TGB42K4dY8oRmtJyi",
      "preview-src-list": _vm.srcList6
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "地址配置：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticClass: "frm-tips",
    staticStyle: {
      "height": "280px",
      "border": "1px dotted #409EFF"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上边距(vh)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入上边距"
    },
    model: {
      value: (_vm.form.dzMarginTop),
      callback: function($$v) {
        _vm.$set(_vm.form, "dzMarginTop", $$v)
      },
      expression: "form.dzMarginTop"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        默认值：上边距 20\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "奖品弹窗图：",
      "rules": _vm.rules.tan_img
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('tan_img', _vm.index)
      }
    }
  }, [(_vm.form.tan_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.tan_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        注：奖品图片|只能上传jpg/png文件，外部弹出层：730*1000，内部弹窗居中最大宽度限制：580px\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": "https://b-img-cdn.yaoking.cn/1/2024/04/22/f221cb8a3bb5456139f934473ffe940dqhwaRP5aNhT091CvBa0UpE8tjxakxVeJ",
      "preview-src-list": _vm.srcList7
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        上图为示例图，不可编辑\n      ")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "inline-block",
      "margin": "20px"
    },
    attrs: {
      "label": "流水号输入框配置：",
      "rules": _vm.rules.circle_img
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px dotted #409EFF",
      "height": "280px"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "宽度(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入宽度"
    },
    model: {
      value: (_vm.form.lshWidth),
      callback: function($$v) {
        _vm.$set(_vm.form, "lshWidth", $$v)
      },
      expression: "form.lshWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "上边距(vw)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入上边距"
    },
    model: {
      value: (_vm.form.lshMarginTop),
      callback: function($$v) {
        _vm.$set(_vm.form, "lshMarginTop", $$v)
      },
      expression: "form.lshMarginTop"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('el-form-item', {
    attrs: {
      "label": "左边距(%)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入左边距"
    },
    model: {
      value: (_vm.form.lshMarginLeft),
      callback: function($$v) {
        _vm.$set(_vm.form, "lshMarginLeft", $$v)
      },
      expression: "form.lshMarginLeft"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n        默认值：宽度 60，上边距 6，左边距 20\n      ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "首页背景色：",
      "rules": _vm.rules.bac_color
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 20,
      "placeholder": "格式为#abc123"
    },
    model: {
      value: (_vm.form.bac_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bac_color", $$v)
      },
      expression: "form.bac_color"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.entry === 0),
      expression: "form.entry === 0"
    }],
    attrs: {
      "label": "指定货号"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "输入商品货号，用英文逗号隔开！默认所有商品都可以参与"
    },
    model: {
      value: (_vm.form.item_bns),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_bns", $$v)
      },
      expression: "form.item_bns"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动说明：",
      "prop": "activity_explain",
      "rules": _vm.rules.activity_explain
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 200,
      "placeholder": "活动说明"
    },
    model: {
      value: (_vm.form.activity_explain),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_explain", $$v)
      },
      expression: "form.activity_explain"
    }
  })], 1)], 1), _vm._v(" "), (this.form.id) ? _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityActionn()
      }
    }
  }, [_vm._v("保存")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-card', [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "奖品信息",
      "description": "填写相关奖品信息（当前可配置奖品数=6）",
      "type": "success",
      "closable": false,
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.form.credentialArr), function(v, index) {
    return _c('el-card', {
      key: index,
      staticStyle: {
        "width": "40%",
        "display": "inline-block",
        "margin": "20px"
      }
    }, [(!_vm.form.id) ? _c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(255, 145, 0)",
        "font-weight": "600"
      }
    }, [_vm._v("奖品" + _vm._s(index + 1) + "信息:")]), _vm._v(" "), (index != 0) ? _c('el-button', {
      staticStyle: {
        "float": "right",
        "padding": "3px 0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeForm(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "奖品名",
        "rules": _vm.rules.name
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 200,
        "placeholder": "填写奖品名字"
      },
      model: {
        value: (v.name),
        callback: function($$v) {
          _vm.$set(v, "name", $$v)
        },
        expression: "v.name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "奖品等级",
        "rules": _vm.rules.color
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 200,
        "placeholder": "一等奖"
      },
      model: {
        value: (v.color),
        callback: function($$v) {
          _vm.$set(v, "color", $$v)
        },
        expression: "v.color"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n          注：奖品等级，如一等奖、二等奖.....\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "奖品数量",
        "rules": _vm.rules.number
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "maxlength": 200,
        "placeholder": "填写奖品数量"
      },
      model: {
        value: (v.number),
        callback: function($$v) {
          _vm.$set(v, "number", $$v)
        },
        expression: "v.number"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "奖品图片",
        "rules": _vm.rules.img
      }
    }, [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('img', index)
        }
      }
    }, [(v.img) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": v.img
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n            注：奖品图片|只能上传jpg/png文件，尺寸为800*800，且不超过500KB\n          ")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "奖品概率",
        "rules": _vm.rules.probability
      }
    }, [_c('el-col', {
      attrs: {
        "span": 15
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "maxlength": 200,
        "placeholder": "概率为整数1-10000"
      },
      model: {
        value: (v.probability),
        callback: function($$v) {
          _vm.$set(v, "probability", $$v)
        },
        expression: "v.probability"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n              注：后台会自动计算概率，公式=单个概率/所有概率的总和\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "优惠券ID"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "maxlength": 200,
        "placeholder": "优惠券ID"
      },
      model: {
        value: (v.coupon_id),
        callback: function($$v) {
          _vm.$set(v, "coupon_id", $$v)
        },
        expression: "v.coupon_id"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n            注：没有不填，默认为空\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.platform === 'pos'),
        expression: "form.platform === 'pos'"
      }],
      attrs: {
        "label": "奖品梯级"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "type": "level",
        "maxlength": 200,
        "placeholder": "金额"
      },
      model: {
        value: (v.level),
        callback: function($$v) {
          _vm.$set(v, "level", $$v)
        },
        expression: "v.level"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("\n            注：没有不填，默认为空\n          ")])], 1)], 1)
  }), _vm._v(" "), (!_vm.form.id) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.addRule()
      }
    }
  }, [_vm._v("+增加奖品")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.id > 0) ? _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAllPrizes()
      }
    }
  }, [_vm._v("保存所有奖品")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), (!_vm.form.id) ? _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")])], 1) : _vm._e(), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-667eea7d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667eea7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/lotteryactivity/add.vue
// module id = 2788
// module chunks = 0